import type { CSS } from '@truepill/capsule-utils'
import { Chip } from '@truepill/react-capsule'
import { ReactComponent as PetIcon } from 'assets/icons/paw.svg'

const SpeciesLogo = ({ isHuman, css }: { isHuman: boolean; css?: CSS }) => {
  return !isHuman ? (
    <Chip css={css} data-testid="pet-species-chip">
      <PetIcon style={{ verticalAlign: 'bottom', margin: '0' }} />
    </Chip>
  ) : (
    <></>
  )
}

export default SpeciesLogo
